import React, { Component } from 'react';
import { Grid,Row,Col,Panel,FormGroup,FormControl,Button,InputGroup,Image,Radio } from 'react-bootstrap';
import { Link,Redirect } from 'react-router-dom'
import './Card.css';
import { API_ROOT } from '../../config.js';
import spinner from '../Header/Spinner-1s-150px.svg'
import {Helmet} from 'react-helmet'

class Card extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardDetail: '',
      message: '',
      name: '',
      contact: '',
      address: '',
      city: '',
      postcode: '',
      state: '',
      country: '',
      cardId: this.props.cdid,
      blnMessage: null,
      blnName: null,
      blnContact: null,
      blnAddress: null,
      blnPostcode: null,
      blnState: null,
      blnCountry: null,
      blnQuantity: null,
      blnRedirect: false,
      isLoading: true,
      wishStyle: {display: 'block'},
      quantityStyle: {display: 'none'},
      orderType: "1",
      quantity: 5,
      price: null
    }

    this.handleInputChange = this.handleInputChange.bind(this)
  }

  componentDidMount () {

    var api = ''
    if(this.props.orderid != null){
      api = `${API_ROOT}/orders/${this.props.orderid}`
    }
    else if (this.props.cdname != null) {
      api = `${API_ROOT}/cards/${this.props.cdname}`
    }
    else {
      api = `${API_ROOT}/cards/${this.props.cdid}`
    }

    const token = localStorage.getItem('token');
    fetch(api, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
    .then ( response => {
      if ( response.ok ) {
        return response.json();
      }
    })
    .then(data => {
      var details = this.props.orderid != null ? data.orders : data.card
      document.title = details.card_name + " greeting card, we mail your wishes - NaleyCards Malaysia"

      this.props.subject(this.renderSubject(details))

      this.setState({price:new Intl.NumberFormat('ms-MY', {minimumFractionDigits: 2}).format(details.price)})
      this.setState({cardDetail:this.renderCardDetail(details),isLoading:false})

      if(this.props.orderid != null){
        this.setState({message:details.message})
        this.setState({name:details.recipient})
        this.setState({contact:details.contact})
        this.setState({address:details.address})
        this.setState({city:details.city})
        this.setState({postcode:details.postcode})
        this.setState({state:details.state})
        this.setState({country:details.country})
        this.setState({orderType:details.order_type+""})
        this.setState({quantity:details.quantity})

        if(details.order_type === 2) {
          this.setState({wishStyle: {display: 'none'}})
          this.setState({quantityStyle: {display: 'block'}})
        }
      }
      this.setState({cardId:details.card_id})
      //console.log(this.state)
    })
    .catch((error) =>{
        //console.error(error);
    })

  }

  componentWillUnmount() {
    if (this.props.subject != null) {
      this.props.subject('')
    }
  }

  renderCardDetail(data){
    return (
      <div className="card-detail">
        <Image src={data.large_image} alt={data.card_name + " greeting card"}
        title={"Save this card " + data.card_name + ", we mail for you"} responsive />
      </div>
    )
  }

  renderSubject(data){
    let parentUrl = '/cards'
    let parentLabel = 'Cards'
    if (this.props.orderid != null) {
      parentUrl = '/orders'
      parentLabel = 'Saved'
    }

    let categUrl = "/category/" + data.category_id
    if (data.seo_url !== '') {
      categUrl = '/' + data.seo_url
    }

    let formattedPrice = 'RM' + new Intl.NumberFormat('ms-MY',{minimumFractionDigits: 2}).format(data.price)

    return (
      <div>
          <Link to={parentUrl} title="Choose a greeting card">{parentLabel} </Link>
          / <Link to={categUrl} title={data.category_name + " greeting cards"}>{data.category_name} Cards </Link>
          / <span>{data.card_name} Card - </span>
          {data.category_id === 125555 ? (
            <React.Fragment><del>RM9.90</del><span style={{color: '#ff7878'}}> <b>{formattedPrice}</b></span></React.Fragment>
          ) : (
            <span>{formattedPrice}</span>
          )}

      </div>
      )
  }

  handleInputChange(event) {
    const target = event.target;
    const tvalue = target.type === 'checkbox' ? target.checked : target.value;
    const tname = target.id;

    this.setState({
      [tname]: tvalue
    })

    if(tname === 'orderType') {
      if (tvalue === "2") {
        this.setState({wishStyle: {display: 'none'}})
        this.setState({quantityStyle: {display: 'block'}})
      }
      else {
        this.setState({wishStyle: {display: 'block'}})
        this.setState({quantityStyle: {display: 'none'}})
      }
    }

    if(tname === 'message' && this.state.blnMessage !== null && tvalue.length > 0){
      this.setState({blnMessage: null});
    }
    if(tname === 'name' && this.state.blnName !== null && tvalue.length > 0){
      this.setState({blnName: null});
    }
    if(tname === 'contact' && this.state.blnContact !== null && tvalue.length > 0){
      this.setState({blnContact: null});
    }
    if(tname === 'address' && this.state.blnAddress !== null && tvalue.length > 0){
      this.setState({blnAddress: null});
    }
    if(tname === 'postcode' && this.state.blnPostcode !== null && tvalue.length > 0){
      this.setState({blnPostcode: null});
    }
    if(tname === 'state' && this.state.blnState !== null && tvalue.length > 0){
      this.setState({blnState: null});
    }
    if(tname === 'country' && this.state.blnCountry !== null && tvalue.length > 0){
      this.setState({blnCountry: null});
    }
    if(tname === 'quantity' && this.state.blnQuantity !== null && tvalue.length > 0){
      this.setState({blnQuantity: null});
    }

    //console.log(this.state);
  }

  handleFormSubmit(event){
    event.preventDefault()

    var blnError = false
    this.setState({errorMessage: ''})
    var errorField = []

    if(this.state.message.length === 0 && this.state.orderType === "1"){
      this.setState({blnMessage: 'error'})
      errorField.push('wishes')
      blnError = true
    }
    if(this.state.quantity < 1 && this.state.orderType === "2"){
      this.setState({blnQuantity: 'error'})
      errorField.push('quantity')
      blnError = true
    }
    if(this.state.name.length === 0){
      this.setState({blnName: 'error'})
      errorField.push('name')
      blnError = true
    }
    if(this.state.contact.length === 0){
      this.setState({blnContact: 'error'})
      errorField.push('contact number')
      blnError = true
    }
    if(this.state.address.length === 0){
      this.setState({blnAddress: 'error'})
      errorField.push('address')
      blnError = true
    }
    if(this.state.postcode.length === 0){
      this.setState({blnPostcode: 'error'})
      errorField.push('postcode')
      blnError = true
    }
    if(this.state.state.length === 0){
      this.setState({blnState: 'error'})
      errorField.push('state')
      blnError = true
    }
    if(this.state.country.length === 0){
      this.setState({blnCountry: 'error'})
      errorField.push('country')
      blnError = true
    }
    if(blnError === true){
      var errorMessage = 'Please fill in'
      if (errorField.length === 1) {
        errorMessage += ' ' + errorField[0] + '.'
      }
      else {
        for (var i = 0; i < errorField.length; i++) {
          if (i !== errorField.length-1) {
            errorMessage += ' ' + errorField[i] + ', '
          }
          else {
            errorMessage = errorMessage.substring(0, errorMessage.length-2)
            errorMessage += ' and ' + errorField[i] + '.'
          }
        }
      }

      this.setState({errorMessage: errorMessage})
      return
    }

    var formApi = ''
    var method = ''
    if(this.props.orderid != null){
      formApi = `${API_ROOT}/orders/${this.props.orderid}`
      method = 'PUT'
    }
    else {
      formApi = `${API_ROOT}/orders`
      method = 'POST'
    }
    //console.log(formApi, method)

    fetch(formApi, {
      method: method,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      },
      body: JSON.stringify(this.state),
    })
    .then ( response => {
      if ( response.ok ) {
        if (this.props.orderid == null){
          this.props.savedCount(1)
        }
        this.setState({blnRedirect:true})
        return response.json();
      }
    })
    .catch((error) =>{
      //console.error(error);
    })
  }

  renderHeaderMeta() {
    if (this.props.cdname !== undefined && this.props.categ !== undefined) {
      let canonicalUrl = "https://www.naleycards.com/" + this.props.categ + "-cards/" + this.props.cdname
      return (
        <Helmet>
          <link rel="canonical" href={canonicalUrl} />
        </Helmet>
      )
    }
  }

  render() {
    if (this.state.blnRedirect === true) {
      return (<Redirect to="/orders" />)
    }

    return (
<Grid fluid>
{this.renderHeaderMeta()}
{this.state.isLoading === true && (
  <Row>
  <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
  </Row>
)}
  <form onSubmit={(event) => this.handleFormSubmit(event)}>
  <Row>
    <Col xs={12} sm={3} md={3} lg={3}>
      {this.state.cardDetail}
    </Col>

    <Col xs={12} sm={4} md={4} lg={4}>
      <FormGroup>
        <Radio name="orderType" id="orderType" value="1" checked={this.state.orderType === '1'} onChange={(event) => this.handleInputChange(event)}>
          Write wishes and we'll mail cards for you, or
        </Radio>
        <Radio name="orderType" id="orderType" value="2" checked={this.state.orderType === '2'} onChange={(event) => this.handleInputChange(event)}>
          Send blank cards to yourself
        </Radio>
      </FormGroup>

      <div style={this.state.wishStyle}>
      <FormGroup controlId="message" bsClass="card-textarea form-group" validationState={this.state.blnMessage}>
        <FormControl componentClass="textarea" rows={9} placeholder="Your wishes to recipient" value={this.state.message}
        onChange={this.handleInputChange} />
      </FormGroup>
      </div>

      <div style={this.state.quantityStyle}>
      <FormGroup controlId="quantity" validationState={this.state.blnQuantity}>
        <InputGroup>
          <InputGroup.Addon bsClass="input-group-addon addon-text">Quantity</InputGroup.Addon>
          <FormControl type="text" onChange={this.handleInputChange} value={this.state.quantity}/>
        </InputGroup>
      </FormGroup>
      </div>
    </Col>

    <Col xs={12} sm={5} md={5} lg={5}>
      <Panel bsStyle="info">
        <Panel.Heading>
          <Panel.Title>Recipient Info</Panel.Title>
        </Panel.Heading>
        <Panel.Body>
          <FormGroup controlId="name" validationState={this.state.blnName}>
            <InputGroup>
              <InputGroup.Addon bsClass="input-group-addon addon-text">Name</InputGroup.Addon>
              <FormControl type="text" onChange={this.handleInputChange} value={this.state.name}/>
            </InputGroup>
          </FormGroup>
          <FormGroup controlId="contact" validationState={this.state.blnContact}>
            <InputGroup>
              <InputGroup.Addon bsClass="input-group-addon addon-text">Contact Number</InputGroup.Addon>
              <FormControl type="text" onChange={this.handleInputChange} value={this.state.contact}/>
            </InputGroup>
          </FormGroup>
          <FormGroup controlId="address" validationState={this.state.blnAddress}>
            <InputGroup>
              <InputGroup.Addon bsClass="input-group-addon addon-text">Address</InputGroup.Addon>
              <FormControl type="text" placeholder="Unit No., Street Address, etc" value={this.state.address} onChange={this.handleInputChange} />
            </InputGroup>
          </FormGroup>
          <FormGroup controlId="city">
            <InputGroup>
              <InputGroup.Addon bsClass="input-group-addon addon-text">City</InputGroup.Addon>
              <FormControl type="text" value={this.state.city} onChange={this.handleInputChange} />
            </InputGroup>
          </FormGroup>
          <FormGroup controlId="postcode" validationState={this.state.blnPostcode}>
            <InputGroup>
              <InputGroup.Addon bsClass="input-group-addon addon-text">Postcode</InputGroup.Addon>
              <FormControl type="text" value={this.state.postcode} onChange={this.handleInputChange} />
            </InputGroup>
          </FormGroup>
          <FormGroup controlId="state" validationState={this.state.blnState}>
            <InputGroup>
              <InputGroup.Addon bsClass="input-group-addon addon-text">State</InputGroup.Addon>
              <FormControl type="text" value={this.state.state} onChange={this.handleInputChange} />
            </InputGroup>
            {/*<InputGroup>
              <InputGroup.Addon bsClass="input-group-addon addon-text">State</InputGroup.Addon>
              <FormControl componentClass="select" placeholder="State" value={this.state.state} onChange={this.handleInputChange}>
                <option value="">- Select State -</option>
                <option value="johor">Johor</option>
                <option value="kedah">Kedah</option>
                <option value="kelantan">Kelantan</option>
                <option value="kuala lumpur">Kuala Lumpur</option>
                <option value="labuan">Labuan</option>
                <option value="melaka">Melaka</option>
                <option value="negeri sembilan">Negeri Sembilan</option>
                <option value="pahang">Pahang</option>
                <option value="perak">Perak</option>
                <option value="perlis">Perlis</option>
                <option value="pulau pinang">Pulau Pinang</option>
                <option value="putrajaya">Putrajaya</option>
                <option value="sabah">Sabah</option>
                <option value="sarawak">Sarawak</option>
                <option value="selangor">Selangor</option>
                <option value="terengganu">Terengganu</option>
              </FormControl>
              </InputGroup>*/}
            </FormGroup>
            <FormGroup controlId="country" validationState={this.state.blnCountry}>
              <InputGroup>
                <InputGroup.Addon bsClass="input-group-addon addon-text">Country</InputGroup.Addon>
                <FormControl type="text" value={this.state.country} onChange={this.handleInputChange} />
              </InputGroup>
              {/*<InputGroup.Addon bsClass="input-group-addon addon-text">Country</InputGroup.Addon>
                <FormControl componentClass="select" placeholder="Malaysia" onChange={this.handleInputChange}>
                  <option value="malaysia">Malaysia</option>
                </FormControl>
              </InputGroup>*/}
            </FormGroup>

        </Panel.Body>
      </Panel>
      <span className="nl-button">
        <span className="error">{this.state.errorMessage}</span>
        <Button block bsSize="lg" type="submit">
          {this.props.orderid != null? ("Update"):("Save")} Card...
        </Button>
      </span>
    </Col>
  </Row>
  <Row>
    <Col xs={12} sm={12} md={12} lg={12}></Col>
  </Row>
  </form>

</Grid>
    );
  }
}

export default Card;
